<template>
  <v-row @wheel="onMouseWheel" no-gutters class="gallery"  >
    <v-row
      class="flex-nowrap scroller"
      :class="{snap: !mousedown}"
      ref="slider"
      @mouseleave="onMouseLeave"

      @mousedown="onMouseDown"
      @touchstart="onMouseDown"

      @mouseup="onMouseUp"
      @click.capture="onMouseClick"
      @touchend="onMouseUp"

      @mousemove.prevent="onMouseMove"
      @touchmove="onMouseMove"

      >
      <v-col
        :cols="cols"
        ref="image"
        v-for="(galleryElement, i) in galleryArray"
        :key="i"
        class="scroll-child fill-height"
        @mousedown="onGalleryElementMouseDown($event, galleryElement)"
        @toushstart="onGalleryElementMouseDown($event, galleryElement)"
        @mouseup="onGalleryElementMouseUp($event, galleryElement)"
        @touchend="onGalleryElementMouseUp($event, galleryElement)"
        >
          <TalkCard :data="galleryElement" :style="{minHeight: '100%', margin: '0 auto'}" />
      </v-col>
      <!-- <v-col class="scroll-child fill-height" :cols="cols"></v-col>
      <v-col class="scroll-child fill-height" :cols="cols"></v-col> -->
      <template v-if="!noSpaceRight">
        <v-col class="scroll-child" :cols="cols"></v-col>
        <!-- <v-col class="scroll-child" v-if="cols < 9" :cols="cols"></v-col>
        <v-col class="scroll-child" v-if="cols < 5" :cols="cols"></v-col>
        <v-col class="scroll-child" v-if="cols < 4" :cols="cols"></v-col> -->
        <!-- <v-col class="scroll-child" :cols="cols"><v-responsive width="100%" :height="viewPort.height * 0.5" /></v-col>
        <v-col class="scroll-child" :cols="cols"><v-responsive width="100%" :height="viewPort.height * 0.5" /></v-col>
        <v-col class="scroll-child" :cols="cols"><v-responsive width="100%" :height="viewPort.height * 0.5" /></v-col> -->
      </template>
    </v-row>
    <transition>
      <v-btn fab light style="top: -20px;" v-if="selectedImage !== 0" @click="selectedImage = Math.max(0, Math.min(galleryArray.length - 1, selectedImage - 1))"  absolute><v-icon>mdi-chevron-left</v-icon></v-btn>
    </transition>
    <transition>
      <v-btn fab light style="top: -20px;" v-if="selectedImage !== galleryArray.length - 1" @click="selectedImage = Math.max(0, Math.min(galleryArray.length - 1, selectedImage + 1))" absolute right ><v-icon>mdi-chevron-right</v-icon></v-btn>
    </transition>
  </v-row>
</template>

<script>
import { Viewport } from '@monogrid/vue-lib'
import { ElasticNumber, RAF, normalizeWheel } from '@monogrid/js-utils'
import delay from 'lodash/delay'
import TalkCard from '@/molecules/TalkCard'

export default {
  name: 'ContentGallery2',
  mixins: [Viewport],
  components: {
    TalkCard
  },
  data () {
    return {
      mousedown: false,
      startX: 0,
      scrollLeft: 0,
      selectedImage: 0,
      walk: 0,
      oldWalk: 0,
      scrollValue: new ElasticNumber(0)
    }
  },
  props: {
    data: {
      type: [Object, Array],
      required: true
    },
    noSpaceRight: {
      type: Boolean,
      required: false,
      default: false
    },
    wheel: {
      type: Boolean,
      required: false,
      default: false
    },
    cols: {
      type: Number,
      required: false,
      default () {
        return 3
      }
    }
  },
  computed: {
    galleryArray () {
      if (Array.isArray(this.data)) return this.data
      return this.data.images
    }
  },
  mounted () {
    this.scrollValue.speed = 10
    this.time = new Date().getTime()
    RAF.add(this.onUpdate)
  },
  destroyed () {
    RAF.remove(this.onUpdate)
  },
  watch: {
    data () {
      this.scrollValue.value = this.scrollValue.target = 0
    },
    selectedImage (value) {
      this.onSelectedImageChange(value)
    }
  },
  methods: {
    onMouseClick (e) {
      // console.log('mouse click')
      if (Math.abs(this.oldWalk) > 50) {
        // console.log('stop mouse click')
        e.preventDefault()
        e.stopPropagation()
      }
      this.$emit('click')
    },
    onMouseWheel (e) {
      // if (!this.wheel) return
      // console.log('ok')
      const evt = normalizeWheel(e)
      if (evt.pixelX !== 0) e.preventDefault()
      this.scrollValue.target += this.wheel ? evt.pixelY + evt.pixelX : (event.pixelX || 0)
      if (this.wheelTimeout) clearTimeout(this.wheelTimeout)
      this.wheelTimeout = delay(this.onMouseUp, 100)
    },
    onGalleryElementMouseDown (e, image) {
      this.imageClickStart = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
    },
    onGalleryElementMouseUp (e, image) {
      const imageClickEnd = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
      if (Math.abs(imageClickEnd - this.imageClickStart) < 10) {
        this.fullscreenElement = image
        this.fullscreenOpen = true
        this.lastFullScreenElementIndex = this.fullscreenElementIndex
      }
    },
    onImageClick (image) {
    },
    onUpdate () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000

      if (this.$refs.image && this.$refs.slider) {
        let width = 0
        let lastWidth = 0
        this.$refs.image.forEach(image => {
          lastWidth = image.getBoundingClientRect().width
          width += lastWidth
        })
        width += lastWidth
        width -= this.$refs.slider.getBoundingClientRect().width
        this.scrollValue.target = Math.max(0, Math.min(width, this.scrollValue.target))
      }

      this.scrollValue.update(Math.min(delta, 1 / 10))
      this.$refs.slider.scrollLeft = this.scrollValue.value
      this.time = now
    },
    onMouseDown (e) {
      this.mousedown = true
      // this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.startX = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
      this.scrollLeft = this.scrollValue.target
    },
    onMouseMove (e) {
      if (!this.mousedown) return
      this.walk = (e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX) - this.startX
      this.scrollValue.target = this.scrollLeft - this.walk

      if (Math.abs(this.walk) > 50) {
        e.preventDefault()
        // e.stopPropagation()
      }
      // console.log('scrollvalue.target', this.scrollValue.target)
      // if (isNaN(this.scrollValue.target)) {
      //   this.scrollValue.target = 0
      //   console.log('ooops')
      // }
      // console.log(this.walk)
    },
    onSelectedImageChange (value) {
      // console.log('Selected Image', value)
      if (!this.$refs.slider) return
      this.scrollValue.target = this.$refs.slider.getBoundingClientRect().width * (this.cols / 13) * value

      // this.walk = 0

      // if (isNaN(this.scrollValue.target)) {
      //   this.scrollValue.target = 0
      //   console.log('ooops')
      // }
    },

    onMouseLeave (e) {
      this.startX = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
      this.scrollLeft = this.scrollValue.target
      this.onMouseUp(e)
    },

    onMouseUp (e) {
      this.mousedown = false
      let width = 0
      this.$refs.image.forEach(image => {
        width += image.getBoundingClientRect().width
      })
      // width -= this.$refs.slider.getBoundingClientRect().width * 0.5

      const newSelectedImage = Math.floor(this.galleryArray.length * (this.scrollValue.target / width))
      if (newSelectedImage !== this.selectedImage) {
        // console.log('Selected image', newSelectedImage, this.scrollValue.target)
        this.selectedImage = newSelectedImage
      } else {
        if (Math.abs(this.walk) > 50) {
          this.selectedImage = this.selectedImage - (this.walk > 0 ? 1 : -1)
          e.preventDefault()
          e.stopPropagation()
        }
      }
      this.selectedImage = Math.max(0, Math.min(this.galleryArray.length - 1, this.selectedImage))
      // console.log('Selected image final', this.selectedImage, this.scrollValue.target)
      this.oldWalk = this.walk
      this.walk = 0
      this.onSelectedImageChange(this.selectedImage)
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  position: relative;

  // &.invert-ui {
  //   background-color: $c-light-pink;
  // }
}

.go-prev-image,
.go-next-image {
  position: absolute;
  top: 90%;
  transform: translateY(-50%);
  z-index: 1;
  font-size: 1.5rem;

  &.deselected,
  &.v-btn--disabled {
    opacity: 0.2;
    pointer-events: all;
  }
}

.go-prev-image {
  right: 200px;

  @include breakpoint('sm-and-down') {
    right: 40px;
  }
}

.go-next-image {
  right: 160px;

  @include breakpoint('sm-and-down') {
    right: 0;
  }
}

// .selected-image,
// .total-images {
//   position: absolute;
//   top: 90%;
//   pointer-events: none;
//   user-select: none;
//   transform: translateY(-50%);
//   font-family: 'Domaine Sans Display', sans-serif;
//   z-index: 1;

//   .expanded-diplay-mode.invert-ui & {
//     color: map-get($shades, 'white');
//     mix-blend-mode: difference;
//   }

//   .compact-display-mode & {
//     left: 30px;
//     width: 500px;
//     white-space: nowrap;
//     transform: translateY(0) translateX(-100%);
//     text-align: right;
//     font-size: 10rem;
//   }

// }

// .selected-image {
//   left: 50px;
//   font-size: 2rem;

//   @include breakpoint('sm-and-down') {
//     left: initial;
//     font-size: 2rem;
//     display: inline-block;
//   }

//   .compact-display-mode & {
//     top: 20%;
//     color: $c-pink;

//     @include breakpoint('sm-and-down') {
//       top: 85%;
//       left: 20px;
//       font-size: 2rem;
//       display: inline-block;
//     }
//   }
// }

// .total-images {
//   right: 250px;
//   font-size: 4rem;
//   opacity: 0.7;

//   @include breakpoint('sm-and-down') {
//     left: 45px;
//     right: initial;
//     font-size: 3rem;
//     display: inline-block;
//   }

//   .compact-display-mode & {
//     top: 45%;
//     opacity: 0.5;

//     @include breakpoint('sm-and-down') {
//       top: 83%;
//       left: 120px;
//       right: initial;
//       font-size: 3rem;
//       display: inline-block;
//     }
//   }
// }

// .gallery-title {
//   position: absolute;
//   top: 0;
//   transform: rotate(-180deg);
//   z-index: 1;
//   text-align: center;
//   height: 100%;
//   left: 0;
//   pointer-events: none;
//   writing-mode: vertical-rl;
//   text-orientation: mixed;

//   .backgroundblendmode & {
//     mix-blend-mode: difference;
//     color: #fff;
//   }
// }

.scroller {
  overflow: hidden;
  // overflow-x: auto;
  position: relative;
  cursor: grabbing;
  // scroll-snap-type: x mandatory;
  user-select: none;

  &.snap {
    cursor: grab;
  }
}

// .scroll-child {
//   border: 1px solid #000;
// }

// .fullscreen-video {
//   height: 100%;
//   left: 50%;
//   transform: translateX(-50%);
//   position: relative;
// }

// .caption {
//   position: absolute;
//   bottom: -50px;
//   // left: 33%;
//   transform: translate(-50%, 0);
//   z-index: 1;
//   font-size: 1rem !important;
//   max-width: 30%;
//   text-align: center;
// }

// .fullscreen-caption {
//   position: absolute;
//   bottom: 5px;
//   left: 50%;
//   width: 100%;
//   transform: translate(-50%, 0);
//   font-size: 1rem !important;
//   text-align: center;
//   color: #fff;
//   mix-blend-mode: difference;
// }

// .image-scroll-child {
//   cursor: pointer;
// }

// .fullscreen-nav-btn {
//   position: absolute;
//   top: 50%;
//   transform: translateY(-50%);
//   width: auto;
//   z-index: 999;

//   &.deselected {
//     opacity: 0.5;
//   }

//   &--prev {
//     left: 10px;
//   }

//   &--next {
//     right: 10px;
//   }

//   svg {
//     width: 20px;
//     height: 20px;

//     g {
//       stroke: currentColor;
//     }
//   }
// }

// dialog top level
// ::v-deep {
//   .fullscreen-gallery-element {
//     overflow: hidden;
//     position: relative;
//     height: 100% !important;
//     max-height: initial !important;
//     box-shadow: none !important;
//     border-radius: 0 !important;
//     margin: 0 !important;
//   }
// }
// container for fullscreen item, not including arrows or mobile caption
// .fullscreen-element-container {
//   position: relative;
//   top: 24px;
//   height: calc(100% - 48px);
//   width: calc(100% - 48px);
//   margin: 0 auto;
// }

.col-2 {
  flex: 0 0 15.384615384615384615384615384615%;
  max-width: 15.384615384615384615384615384615%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 30.76923076923077%;
  max-width: 30.76923076923077%;
}

.col-5 {
  flex: 0 0 38.46153846153846%;
  max-width: 38.46153846153846%;
}

.col-6 {
  flex: 0 0 46.153846153846153846153846153846%;
  max-width: 46.153846153846153846153846153846%;
}

.col-7 {
  flex: 0 0 53.846153846153846153846153846154%;
  max-width: 53.846153846153846153846153846154%;
}

.col-8 {
  flex: 0 0 61.538461538461538461538461538462%;
  max-width: 61.538461538461538461538461538462%;
}

.col-9 {
  flex: 0 0 69.230769230769230769230769230769%;
  max-width: 69.230769230769230769230769230769%;
}

.col-10 {
  flex: 0 0 76.923076923076923076923076923077%;
  max-width: 76.923076923076923076923076923077%;
}

</style>
